import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateService } from '@codeandweb/ngx-translate';

import { Table, TableModule } from '@app/primeng-overrides/table';
import { LazyLoadEvent } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToolbarModule } from 'primeng/toolbar';

import { GlobalModule } from '@app/_global/global.module';
import { environment } from '@environments/environment';
import { EventManagerService, IEventListener } from '@global/event-manager.service';

import { createDownloadFromHttpResponse, uid } from '@helpers/utils';
import { NomenclatureService } from '@app/nomenclature/nomenclature.service';

@Component({
	selector: 'historique-article-dialog',
	templateUrl: './historique-article-dialog.html',
	providers: []
})
export class HistoriqueArticleDialogComponent implements OnInit, IEventListener {

	private _uuid: string = uid();
	get uuid(): string { return this._uuid; }

	@ViewChild('tableHistorique', { static: true }) table: Table;

	values: any[] = [];
	totalRecords: number = 0;
	loading: boolean;
	exportLoading: boolean = false;
	rows: number = environment.default_rows;

	art_id: number;

	constructor(
		private config: DynamicDialogConfig,
		private dialogRef: DynamicDialogRef,
		private eventManager: EventManagerService,
		private translateService: TranslateService,
		private nomenclatureService: NomenclatureService,
	) {
		this.art_id = config.data.art_id;
	}

	ngOnInit(): void {
		this.eventManager.registerEvent('close-modals', this, (args: any) => this.dialogRef.close());
	}


	ngOnDestroy(): void {
		this.eventManager.unregisterEvent('close-modals', this);
	}


	loadHistorique(event: LazyLoadEvent) {
		// https://github.com/primefaces/primeng/issues/8465#issuecomment-617887919
		Promise.resolve(null).then(() => {
			this.loading = true;
		});

		const tmpParams = Object.assign({}, event, {});

		this.nomenclatureService
			.getHistoriqueArticle(this.art_id, tmpParams)
			.subscribe({
				next: ({ total, historique }) => {
					this.totalRecords = total;
					this.values = historique;

					// si on revient sur la liste paginée et que la page en question est vide, on reset
					if (this.values.length === 0 && this.table.first != 0) {
						this.refresh();
					}
				}
			})
			.add(() => {
				this.loading = false;
			});
	}

	refresh(stayOnPage?: boolean) {
		if (!stayOnPage) this.table._first = 0;
		this.table.onLazyLoad.emit(this.table.createLazyLoadMetadata());
	}

	exporterHistorique() {
		this.exportLoading = true;

		this.nomenclatureService.exportHistoriqueArticle(this.art_id)
		.subscribe(response => {
			createDownloadFromHttpResponse(response);
		})
		.add(() => {
			this.exportLoading = false;
		});
	}

}


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		GlobalModule,
		ButtonModule,
		InputTextareaModule,
		TableModule,
		ToolbarModule
	],
	exports: [HistoriqueArticleDialogComponent],
	declarations: [HistoriqueArticleDialogComponent]
})
export class HistoriqueArticleDialogModule { }

